import ApplicationSerializer from './application';
import { camelize } from '@ember/string';

export default class UIHookSerializer extends ApplicationSerializer {
  keyForAttribute(attr) {
    return camelize(attr);
  }

  serialize() {
    const json = super.serialize(...arguments);
    json.data = json.data.map((obj) => obj.attributes);
    json.relationships = [];
    return json;
  }
}
